import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { EnumsContext } from "../../context/EnumsContext";
import { AuditLogFilters as Filters } from "./types";

interface Props {
  filters: Filters;
  onChange: (changes: Partial<Filters>) => void;
}

const AuditLogFilters = ({ filters, onChange }: Props) => {
  const { t } = useTranslation();
  const enumsContext = useContext(EnumsContext);

  const enumOptions = (enumName: string) =>
    (enumsContext?.enums?.[enumName] ?? []).map((val: string) => ({
      label: t(`enums.${enumName}.${val}`, val),
      value: val,
    }));

  const renderEnumSelect = (enumName: string, key: keyof Filters, placeholder: string) => {
    const options = enumOptions(enumName);
    return (
      <Select
        placeholder={placeholder}
        options={options}
        value={options.find((option: any) => option.value === filters[key]) ?? null}
        onChange={(option: any) => onChange({ [key]: option ? option.value : null })}
        isClearable
        classNamePrefix="react-select"
      />
    );
  };

  const renderTextInput = (key: keyof Filters, placeholder: string, type = "search") => (
    <input
      type={type}
      min={type === "number" ? 1 : undefined}
      className="form-control"
      placeholder={placeholder}
      value={filters[key] as string}
      onChange={(e) => onChange({ [key]: e.target.value })}
    />
  );

  const renderDatePicker = (key: "fromDate" | "toDate", placeholder: string) => (
    <DatePicker
      selected={filters[key]}
      onChange={(date: Date | null) => onChange({ [key]: date })}
      placeholderText={placeholder}
      className="form-control"
      wrapperClassName="w-100"
      dateFormat="dd.MM.yyyy"
      isClearable
    />
  );

  const fields = [
    renderTextInput("entityId", t("auditLog.entityId"), "number"),
    renderEnumSelect("auditAction", "action", t("auditLog.selectAction")),
    renderEnumSelect("auditActorType", "actorType", t("auditLog.selectActorType")),
    renderTextInput("actorEmail", t("auditLog.actorEmailPlaceholder")),
    renderTextInput("companyId", t("auditLog.companyId"), "number"),
    renderDatePicker("fromDate", t("auditLog.fromDate")),
    renderDatePicker("toDate", t("auditLog.toDate")),
  ];

  return (
    <Row className="g-2">
      {fields.map((field, index) => (
        <Col key={index} xs={12} sm={6} lg={3}>
          {field}
        </Col>
      ))}
    </Row>
  );
};

export default AuditLogFilters;
